<template>
  <ul class="menu-list">
    <v-divider />
    <div style="color: white"></div>

    <template v-for="(menu, index) in renderMenuList()">
      <router-link :key="`menu-${index + 1}-${menu.name}`" :to="`/${$i18n.locale()}/${menu.path}`">
        <li style="position: relative" tabindex="0">
          <em style="color: #000; position: absolute; left: 18px; top: 18px" :class="menu.icon" />
          <span class="black--text">{{ $t(menu.name) }}</span>
        </li>
      </router-link>
    </template>

    <li
      style="position: relative"
      tabindex="0"
      :data-intro="$t('Click here, if your setting is finished or if you want to sigh out.')"
      @click="logout"
    >
      <em
        style="color: #000; position: absolute; left: 18px; top: 18px"
        class="fas fa-sign-out-alt"
      />
      <span class="black--text">{{ $t('Sign Out') }}</span>
    </li>
  </ul>
</template>

<script>
import MainMenuList from './MainMenuList.js'
export default {
  mixins: [MainMenuList]
}
</script>

<style lang="scss">
.menu.default {
  background-color: #77b0e3 !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-member {
        background-image: url('/static/img/assets/sidebar/member.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }
      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      &.icon-alert-sign {
        background-image: url('/static/img/assets/sidebar/alert-sign.svg');
        fill: white;
      }

      &.icon-executive-management {
        background-image: url('/static/img/assets/sidebar/user-check-solid.svg');
      }

      &.icon-management {
        background-image: url('/static/img/assets/sidebar/map-location-dot-solid.svg');
      }

      &.icon-reporting {
        background-image: url('/static/img/assets/sidebar/reporting.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MenuList/MainMenuList.vue